import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setUserId } from "../lib/api";

export default function AuthSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const uid = params.get("user_id");
    if (uid) {
      setUserId(uid);
      navigate("/new", { replace: true });
    } else {
      navigate("/?error=missing_user_id", { replace: true });
    }
  }, [params, navigate]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 text-slate-600">
      <span className="loading-dot">·</span>
      <span className="loading-dot">·</span>
      <span className="loading-dot">·</span>
    </div>
  );
}
